var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnswer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 58,
    viewBox: "0 0 78 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2609294"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    cx: 49.8462,
    cy: 28.1538,
    r: 28.1538,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Type 4",
    d: "M11.3534 41.9554C14.2164 43.1465 15.9934 45.7271 15.9934 49.3996C15.9934 54.2631 12.538 57.5385 8.09543 57.5385C3.35664 57.5385 0 54.1638 0 49.3996C0 47.1167 0.394899 45.4293 2.17195 40.8636L7.40436 26.7693H15.3023L11.3534 41.9554ZM32.283 41.9554C35.146 43.1465 36.9231 45.7271 36.9231 49.3996C36.9231 54.2631 33.4677 57.5385 29.0251 57.5385C24.2863 57.5385 20.9297 54.1638 20.9297 49.3996C20.9297 47.1167 21.3246 45.4293 23.1016 40.8636L28.334 26.7693H36.232L32.283 41.9554Z",
    fill: "#191919"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.08f0a6fe86980edd1c4b2fd8d9a814dc.svg";
export { ForwardRef as ReactComponent };